//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

const URL = import.meta.env.VITE_LOOKUP_API || `${window.location.origin}/lookups`;

export interface IAddressClient {
	/**
	 * Search for address by post code
	 * @param postcode A valid UK post code
	 * @param houseNumber (optional) The number of the house to be returned
	 * @return A list of UK addresses
	 */
	searchAddresses(postcode: string, houseNumber: string | undefined): Promise<SearchResult[]>;
	/**
	 * Get full address details
	 * @param addressId Address Id
	 * @return Detailed address
	 */
	getFullAddressByAddressId(addressId: string): Promise<FullAddress>;
}

export class AddressClient implements IAddressClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();

		this.baseUrl = baseUrl ?? URL;
	}

	/**
	 * Search for address by post code
	 * @param postcode A valid UK post code
	 * @param houseNumber (optional) The number of the house to be returned
	 * @return A list of UK addresses
	 */
	searchAddresses(
		postcode: string,
		houseNumber: string | undefined,
		cancelToken?: CancelToken,
	): Promise<SearchResult[]> {
		let url_ = this.baseUrl + '/api/v1/Address/SearchAddresses?';
		if (postcode === undefined || postcode === null)
			throw new Error("The parameter 'postcode' must be defined and cannot be null.");
		else url_ += 'Postcode=' + encodeURIComponent('' + postcode) + '&';
		if (houseNumber === null) throw new Error("The parameter 'houseNumber' cannot be null.");
		else if (houseNumber !== undefined) url_ += 'HouseNumber=' + encodeURIComponent('' + houseNumber) + '&';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processSearchAddresses(_response);
			});
	}

	protected processSearchAddresses(response: AxiosResponse): Promise<SearchResult[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<SearchResult[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find addresses with requested postcode.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<SearchResult[]>(null as any);
	}

	/**
	 * Get full address details
	 * @param addressId Address Id
	 * @return Detailed address
	 */
	getFullAddressByAddressId(addressId: string, cancelToken?: CancelToken): Promise<FullAddress> {
		let url_ = this.baseUrl + '/api/v1/Address/GetFullAddressByAddressId/{addressId}';
		if (addressId === undefined || addressId === null) throw new Error("The parameter 'addressId' must be defined.");
		url_ = url_.replace('{addressId}', encodeURIComponent('' + addressId));
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetFullAddressByAddressId(_response);
			});
	}

	protected processGetFullAddressByAddressId(response: AxiosResponse): Promise<FullAddress> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<FullAddress>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find address with requested Id.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<FullAddress>(null as any);
	}
}

export interface IPaymentClient {
	/**
	 * Check bank details via ICE
	 * @param body (optional) Bank details to check
	 * @return Bank details check response
	 */
	checkBankDetails(body: CheckBankDetailsCommand | undefined): Promise<BankCheckerResponse>;
}

export class PaymentClient implements IPaymentClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();

		this.baseUrl = baseUrl ?? URL;
	}

	/**
	 * Check bank details via ICE
	 * @param body (optional) Bank details to check
	 * @return Bank details check response
	 */
	checkBankDetails(body: CheckBankDetailsCommand | undefined, cancelToken?: CancelToken): Promise<BankCheckerResponse> {
		let url_ = this.baseUrl + '/api/v1/Payment/CheckBankDetails';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processCheckBankDetails(_response);
			});
	}

	protected processCheckBankDetails(response: AxiosResponse): Promise<BankCheckerResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<BankCheckerResponse>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('No Content', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<BankCheckerResponse>(null as any);
	}
}

export interface IReferenceDataClient {
	/**
	 * Get all reference data
	 * @return List of options
	 */
	getAllReferenceListData(): Promise<AllReferenceData>;
	/**
	 * Get "hear about us" options
	 * @return List of options
	 */
	getHearAboutUsOptions(): Promise<ReferenceDataItem[]>;
	/**
	 * Get "how long have you been a named driver" options
	 * @return List of options
	 */
	getNamedDriverLengthOnPolicyOptions(): Promise<ReferenceDataItem[]>;
	/**
	 * Get Acorn current policy options
	 * @return List of current policy options
	 */
	getAcornCurrentPolicyOptions(): Promise<ReferenceDataItem[]>;
	/**
	 * Get "claim free for" options
	 * @return List of options
	 */
	getClaimFreeOptions(): Promise<ReferenceDataItem[]>;
	/**
	 * Get cancellation reasons
	 * @return List of cancellation reasons
	 */
	getCancellationReasons(): Promise<ReferenceDataItem[]>;
	/**
	 * Get cancelled policy type
	 * @return List of cancelled policy types
	 */
	getCancelledPolicyTypes(): Promise<ReferenceDataItem[]>;
	/**
	 * Get "How many months did you hold the policy for? " options
	 * @return List of cancelled policy types
	 */
	getHowManyMonthPolicyWithUsOptions(): Promise<ReferenceDataItem[]>;
	/**
	 * Get "How many months did you hold the policy for? " options (CV)
	 * @return List of cancelled policy types
	 */
	getCvHowManyMonthPolicyWithUsOptions(): Promise<ReferenceDataItem[]>;
	/**
	 * Get "How many days did you hold the policy for? " options (Learner Driver)
	 * @return List of cancelled policy types
	 */
	getCvHowManyDaysPolicyWithUsOptions(): Promise<ReferenceDataItem[]>;
	/**
	 * Get titles list
	 * @return List of titles
	 */
	getTitlesList(): Promise<ReferenceDataItem[]>;
	/**
	 * Get genders
	 * @return List of genders.
	 */
	getGenders(): Promise<ReferenceDataItem[]>;
	/**
	 * Get marital status list
	 * @return List of marital statuses
	 */
	getMaritalStatusList(): Promise<ReferenceDataItem[]>;
	/**
	 * Get vehicle fuel types list
	 * @return List of vehicle fuel types
	 */
	getVehicleFuelTypes(): Promise<ReferenceDataItem[]>;
	/**
	 * Get vehicle transmissions
	 * @return List of vehicle transmissions types
	 */
	getVehicleTransmissionsTypes(): Promise<ReferenceDataItem[]>;
	/**
	 * Get vehicle number of doors
	 * @return List of vehicle number of doors
	 */
	getVehicleNumberOfDoorsOptions(): Promise<ReferenceDataItem[]>;
	/**
	 * Get vehicle body types list
	 * @return List of vehicle body types
	 */
	getVehicleBodyTypes(): Promise<ReferenceDataItem[]>;
	/**
	 * Get vehicle ownership options list
	 * @return List of vehicle ownership options
	 */
	getVehicleOwnershipOptions(): Promise<ReferenceDataItem[]>;
	/**
	 * Get Homeowner options list
	 * @return List of Homeowner options
	 */
	getHomeownerOptions(): Promise<ReferenceDataItem[]>;
	/**
	 * Get vehicle use options list
	 * @return List of vehicle use options
	 */
	getVehicleUseOptions(): Promise<ReferenceDataItem[]>;
	/**
	 * Get vehicle use reasons
	 * @return List of vehicle use options
	 */
	getVehicleUseReasons(): Promise<ReferenceDataItem[]>;
	/**
	 * Get vehicle legal owners
	 * @return List of vehicle use options
	 */
	getVehicleLegalOwnerOptions(): Promise<ReferenceDataItem[]>;
	/**
	 * Get vehicle storage locations list
	 * @return List of vehicle storage locations
	 */
	getVehicleStorageOptions(): Promise<ReferenceDataItem[]>;
	/**
	 * Get vehicle keeper options list
	 * @return List of vehicle keeper options
	 */
	getVehicleKeeperOptions(): Promise<ReferenceDataItem[]>;
	/**
	 * Get vehicle modifications list
	 * @return List of vehicle modifications
	 */
	getVehicleModificationsList(): Promise<ReferenceDataItem[]>;
	/**
	 * Get vehicle security list
	 * @return List of vehicle security
	 */
	getVehicleSecurityDevices(): Promise<ReferenceDataItem[]>;
	/**
	 * Get licence types
	 * @return List of licence types
	 */
	getLicenceTypes(): Promise<ReferenceDataItem[]>;
	/**
	 * Get licence restrictions
	 * @return List of licence restrictions
	 */
	getLicenceRestrictions(): Promise<ReferenceDataItem[]>;
	/**
	 * Get additional driving qualifications list
	 * @return List of additional driving qualifications
	 */
	getAdditionalDrivingQualifications(): Promise<ReferenceDataItem[]>;
	/**
	 * Get claim types list
	 * @return List of claim types.
	 */
	getClaimTypes(): Promise<ReferenceDataItem[]>;
	/**
	 * Get claim status list
	 * @return List of claim statuses.
	 */
	getClaimStatues(): Promise<ReferenceDataItem[]>;
	/**
	 * Get medical conditions
	 * @return List of medical conditions.
	 */
	getMedialConditions(): Promise<ReferenceDataItem[]>;
	/**
	 * Get convictions codes
	 * @return List of convictions codes.
	 */
	getConvictionCodes(): Promise<ReferenceDataItem[]>;
	/**
	 * Get level of cover types
	 * @return List of level of cover types
	 */
	getLevelOfCoverTypes(): Promise<ReferenceDataItem[]>;
	/**
	 * Get occupation types
	 * @return List of occupation Types.
	 */
	getOccupationTypes(): Promise<ReferenceDataItem[]>;
	/**
	 * Get industry types
	 * @return List of industry types
	 */
	getIndustryTypes(): Promise<ReferenceDataItem[]>;
	/**
	 * Get policy driving restrictions
	 * @return List of policy driving restrictions
	 */
	getPolicyDrivingRestrictions(): Promise<ReferenceDataItem[]>;
	/**
	 * Get no claims discount types
	 * @return List of no claims discount types
	 */
	getNoClaimsDiscountTypes(): Promise<ReferenceDataItem[]>;
	/**
	 * Get country earned NCD
	 * @return List of countries
	 */
	getCountryEarnedNcdOptions(): Promise<ReferenceDataItem[]>;
	/**
	 * Get years of NCB years
	 * @return List Years of NCB options
	 */
	getNoClaimsBonusYearOptions(): Promise<ReferenceDataItem[]>;
	/**
	 * Get voluntary excess options
	 * @return List of voluntary excess options
	 */
	getGetVoluntaryExcessOptions(): Promise<VolunaryExcessReferenceItem[]>;
	/**
	 * Get mileage increments
	 * @param mileageTypes (optional) The mileage types. If not provided returns the default options.
	 * @return List of no mileage increments options
	 */
	getMileageIncrementOptions(mileageTypes: MileageTypes | undefined): Promise<MileageReferenceItem[]>;
	/**
	 * Get mileage increments
	 * @return List of no mileage increments options
	 * @deprecated
	 */
	getMillageIncrementOptions(): Promise<MileageReferenceItem[]>;
	/**
	 * Get Protect mileage increments
	 * @return List of no mileage increments options
	 * @deprecated
	 */
	getProtectMillageIncrementOptions(): Promise<MileageReferenceItem[]>;
	/**
	 * Get employment status types
	 * @return List of no mileage increments options
	 */
	getEmploymentStatusTypes(): Promise<ReferenceDataItem[]>;
	/**
	 * Get student course status types
	 * @return List of no student courses options
	 */
	getStudentCourseTypes(): Promise<ReferenceDataItem[]>;
	/**
	 * Get relationship to proposer types
	 * @return List of no proposer types options
	 */
	getRelationshipToPropserTypes(): Promise<ReferenceDataItem[]>;
	/**
	 * Get annual taxi claim free years
	 * @return List of annual taxi claim free years options
	 */
	getAnnualTaxiClaimFreeYears(): Promise<ReferenceDataItem[]>;
	/**
	 * Get NCB years on existing Acorn policy
	 * @return List of NCB years on existing Acorn policy options
	 */
	getNoClaimsBonusYearsCurrentAcornPolicy(): Promise<ReferenceDataItem[]>;
	/**
	 * Get Business Radius
	 * @return List of Business Radiuses options
	 */
	getBusinessRadius(): Promise<ReferenceDataItem[]>;
	/**
	 * Get Licencing Areas
	 * @return List of Licencing Areas options
	 */
	getLicencingAreas(): Promise<ReferenceDataItem[]>;
	/**
	 * Get Operators
	 * @return List of Operator options
	 */
	getOperators(): Promise<ReferenceDataItem[]>;
	/**
	 * Get Driver Use
	 * @return List of Driver usage options
	 */
	getDriverUse(): Promise<ReferenceDataItem[]>;
	/**
	 * Get Preferred Contact Methods
	 * @return List of preferred contact method options
	 */
	getPreferredContactMethods(): Promise<ReferenceDataItem[]>;
	/**
	 * Get Delivery Operators
	 * @return List of delivery operator options
	 */
	getDeliveryOperators(): Promise<ReferenceDataItem[]>;
}

export class ReferenceDataClient implements IReferenceDataClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();

		this.baseUrl = baseUrl ?? URL;
	}

	/**
	 * Get all reference data
	 * @return List of options
	 */
	getAllReferenceListData(cancelToken?: CancelToken): Promise<AllReferenceData> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetAllReferenceListData';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetAllReferenceListData(_response);
			});
	}

	protected processGetAllReferenceListData(response: AxiosResponse): Promise<AllReferenceData> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<AllReferenceData>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of options.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<AllReferenceData>(null as any);
	}

	/**
	 * Get "hear about us" options
	 * @return List of options
	 */
	getHearAboutUsOptions(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetHearAboutUsOptions';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetHearAboutUsOptions(_response);
			});
	}

	protected processGetHearAboutUsOptions(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of options.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get "how long have you been a named driver" options
	 * @return List of options
	 */
	getNamedDriverLengthOnPolicyOptions(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetNamedDriverLengthOnPolicyOptions';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetNamedDriverLengthOnPolicyOptions(_response);
			});
	}

	protected processGetNamedDriverLengthOnPolicyOptions(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of options.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get Acorn current policy options
	 * @return List of current policy options
	 */
	getAcornCurrentPolicyOptions(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetAcornCurrentPolicyOptions';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetAcornCurrentPolicyOptions(_response);
			});
	}

	protected processGetAcornCurrentPolicyOptions(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of current policy options.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get "claim free for" options
	 * @return List of options
	 */
	getClaimFreeOptions(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetClaimFreeOptions';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetClaimFreeOptions(_response);
			});
	}

	protected processGetClaimFreeOptions(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of options.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get cancellation reasons
	 * @return List of cancellation reasons
	 */
	getCancellationReasons(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetCancellationReasons';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetCancellationReasons(_response);
			});
	}

	protected processGetCancellationReasons(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of cancellation reasons.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get cancelled policy type
	 * @return List of cancelled policy types
	 */
	getCancelledPolicyTypes(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetCancelledPolicyTypes';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetCancelledPolicyTypes(_response);
			});
	}

	protected processGetCancelledPolicyTypes(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of cancelled policy types.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get "How many months did you hold the policy for? " options
	 * @return List of cancelled policy types
	 */
	getHowManyMonthPolicyWithUsOptions(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetHowManyMonthPolicyWithUsOptions';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetHowManyMonthPolicyWithUsOptions(_response);
			});
	}

	protected processGetHowManyMonthPolicyWithUsOptions(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of cancelled policy types.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get "How many months did you hold the policy for? " options (CV)
	 * @return List of cancelled policy types
	 */
	getCvHowManyMonthPolicyWithUsOptions(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetCvHowManyMonthPolicyWithUsOptions';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetCvHowManyMonthPolicyWithUsOptions(_response);
			});
	}

	protected processGetCvHowManyMonthPolicyWithUsOptions(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of cancelled policy types.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get "How many days did you hold the policy for? " options (Learner Driver)
	 * @return List of cancelled policy types
	 */
	getCvHowManyDaysPolicyWithUsOptions(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetCvHowManyDaysPolicyWithUsOptions';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetCvHowManyDaysPolicyWithUsOptions(_response);
			});
	}

	protected processGetCvHowManyDaysPolicyWithUsOptions(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of cancelled policy types.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get titles list
	 * @return List of titles
	 */
	getTitlesList(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetTitlesList';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetTitlesList(_response);
			});
	}

	protected processGetTitlesList(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of titles.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get genders
	 * @return List of genders.
	 */
	getGenders(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetGenders';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetGenders(_response);
			});
	}

	protected processGetGenders(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of genders.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get marital status list
	 * @return List of marital statuses
	 */
	getMaritalStatusList(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetMaritalStatusList';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetMaritalStatusList(_response);
			});
	}

	protected processGetMaritalStatusList(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of marital statuses.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get vehicle fuel types list
	 * @return List of vehicle fuel types
	 */
	getVehicleFuelTypes(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetVehicleFuelTypes';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetVehicleFuelTypes(_response);
			});
	}

	protected processGetVehicleFuelTypes(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of vehicle fuel types.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get vehicle transmissions
	 * @return List of vehicle transmissions types
	 */
	getVehicleTransmissionsTypes(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetVehicleTransmissionsTypes';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetVehicleTransmissionsTypes(_response);
			});
	}

	protected processGetVehicleTransmissionsTypes(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of vehicle transmissions types.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get vehicle number of doors
	 * @return List of vehicle number of doors
	 */
	getVehicleNumberOfDoorsOptions(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetVehicleNumberOfDoorsOptions';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetVehicleNumberOfDoorsOptions(_response);
			});
	}

	protected processGetVehicleNumberOfDoorsOptions(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of vehicle number of doors.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get vehicle body types list
	 * @return List of vehicle body types
	 */
	getVehicleBodyTypes(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetVehicleBodyTypes';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetVehicleBodyTypes(_response);
			});
	}

	protected processGetVehicleBodyTypes(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of vehicle body types.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get vehicle ownership options list
	 * @return List of vehicle ownership options
	 */
	getVehicleOwnershipOptions(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetVehicleOwnershipOptions';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetVehicleOwnershipOptions(_response);
			});
	}

	protected processGetVehicleOwnershipOptions(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of vehicle ownership options.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get Homeowner options list
	 * @return List of Homeowner options
	 */
	getHomeownerOptions(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetHomeownerOptions';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetHomeownerOptions(_response);
			});
	}

	protected processGetHomeownerOptions(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of Homeowner options.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get vehicle use options list
	 * @return List of vehicle use options
	 */
	getVehicleUseOptions(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetVehicleUseOptions';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetVehicleUseOptions(_response);
			});
	}

	protected processGetVehicleUseOptions(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of vehicle use options.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get vehicle use reasons
	 * @return List of vehicle use options
	 */
	getVehicleUseReasons(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetVehicleUseReasons';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetVehicleUseReasons(_response);
			});
	}

	protected processGetVehicleUseReasons(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of vehicle use options.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get vehicle legal owners
	 * @return List of vehicle use options
	 */
	getVehicleLegalOwnerOptions(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetVehicleLegalOwnerOptions';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetVehicleLegalOwnerOptions(_response);
			});
	}

	protected processGetVehicleLegalOwnerOptions(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of vehicle legal owner options.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get vehicle storage locations list
	 * @return List of vehicle storage locations
	 */
	getVehicleStorageOptions(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetVehicleStorageOptions';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetVehicleStorageOptions(_response);
			});
	}

	protected processGetVehicleStorageOptions(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of vehicle storage locations.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get vehicle keeper options list
	 * @return List of vehicle keeper options
	 */
	getVehicleKeeperOptions(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetVehicleKeeperOptions';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetVehicleKeeperOptions(_response);
			});
	}

	protected processGetVehicleKeeperOptions(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of vehicle keeper options.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get vehicle modifications list
	 * @return List of vehicle modifications
	 */
	getVehicleModificationsList(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetVehicleModificationsList';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetVehicleModificationsList(_response);
			});
	}

	protected processGetVehicleModificationsList(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of vehicle modifications.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get vehicle security list
	 * @return List of vehicle security
	 */
	getVehicleSecurityDevices(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetVehicleSecurityDevices';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetVehicleSecurityDevices(_response);
			});
	}

	protected processGetVehicleSecurityDevices(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of vehicle security.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get licence types
	 * @return List of licence types
	 */
	getLicenceTypes(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetLicenceTypes';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetLicenceTypes(_response);
			});
	}

	protected processGetLicenceTypes(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of licence types.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get licence restrictions
	 * @return List of licence restrictions
	 */
	getLicenceRestrictions(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetLicenceRestrictions';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetLicenceRestrictions(_response);
			});
	}

	protected processGetLicenceRestrictions(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of licence restrictions.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get additional driving qualifications list
	 * @return List of additional driving qualifications
	 */
	getAdditionalDrivingQualifications(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetAdditionalDrivingQualifications';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetAdditionalDrivingQualifications(_response);
			});
	}

	protected processGetAdditionalDrivingQualifications(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException(
				'Could not find the list of additional driving qualifications.',
				status,
				_responseText,
				_headers,
			);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get claim types list
	 * @return List of claim types.
	 */
	getClaimTypes(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetClaimTypes';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetClaimTypes(_response);
			});
	}

	protected processGetClaimTypes(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of claim types.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get claim status list
	 * @return List of claim statuses.
	 */
	getClaimStatues(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetClaimStatues';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetClaimStatues(_response);
			});
	}

	protected processGetClaimStatues(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of claim statuses.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get medical conditions
	 * @return List of medical conditions.
	 */
	getMedialConditions(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetMedialConditions';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetMedialConditions(_response);
			});
	}

	protected processGetMedialConditions(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of medical conditions.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get convictions codes
	 * @return List of convictions codes.
	 */
	getConvictionCodes(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetConvictionCodes';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetConvictionCodes(_response);
			});
	}

	protected processGetConvictionCodes(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of convictions codes.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get level of cover types
	 * @return List of level of cover types
	 */
	getLevelOfCoverTypes(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetLevelOfCoverTypes';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetLevelOfCoverTypes(_response);
			});
	}

	protected processGetLevelOfCoverTypes(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of level of cover types.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get occupation types
	 * @return List of occupation Types.
	 */
	getOccupationTypes(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetOccupationTypes';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetOccupationTypes(_response);
			});
	}

	protected processGetOccupationTypes(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of occupation Types.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get industry types
	 * @return List of industry types
	 */
	getIndustryTypes(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetIndustryTypes';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetIndustryTypes(_response);
			});
	}

	protected processGetIndustryTypes(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of industry types.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get policy driving restrictions
	 * @return List of policy driving restrictions
	 */
	getPolicyDrivingRestrictions(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetPolicyDrivingRestrictions';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetPolicyDrivingRestrictions(_response);
			});
	}

	protected processGetPolicyDrivingRestrictions(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of policy driving restrictions.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get no claims discount types
	 * @return List of no claims discount types
	 */
	getNoClaimsDiscountTypes(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetNoClaimsDiscountTypes';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetNoClaimsDiscountTypes(_response);
			});
	}

	protected processGetNoClaimsDiscountTypes(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of no claims discount types.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get country earned NCD
	 * @return List of countries
	 */
	getCountryEarnedNcdOptions(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetCountryEarnedNcdOptions';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetCountryEarnedNcdOptions(_response);
			});
	}

	protected processGetCountryEarnedNcdOptions(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of countries.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get years of NCB years
	 * @return List Years of NCB options
	 */
	getNoClaimsBonusYearOptions(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetNoClaimsBonusYearOptions';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetNoClaimsBonusYearOptions(_response);
			});
	}

	protected processGetNoClaimsBonusYearOptions(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of NCB options.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get voluntary excess options
	 * @return List of voluntary excess options
	 */
	getGetVoluntaryExcessOptions(cancelToken?: CancelToken): Promise<VolunaryExcessReferenceItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetGetVoluntaryExcessOptions';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetGetVoluntaryExcessOptions(_response);
			});
	}

	protected processGetGetVoluntaryExcessOptions(response: AxiosResponse): Promise<VolunaryExcessReferenceItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<VolunaryExcessReferenceItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of voluntary excess options.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<VolunaryExcessReferenceItem[]>(null as any);
	}

	/**
	 * Get mileage increments
	 * @param mileageTypes (optional) The mileage types. If not provided returns the default options.
	 * @return List of no mileage increments options
	 */
	getMileageIncrementOptions(
		mileageTypes: MileageTypes | undefined,
		cancelToken?: CancelToken,
	): Promise<MileageReferenceItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetMileageIncrementOptions?';
		if (mileageTypes === null) throw new Error("The parameter 'mileageTypes' cannot be null.");
		else if (mileageTypes !== undefined) url_ += 'mileageTypes=' + encodeURIComponent('' + mileageTypes) + '&';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetMileageIncrementOptions(_response);
			});
	}

	protected processGetMileageIncrementOptions(response: AxiosResponse): Promise<MileageReferenceItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<MileageReferenceItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of mileage increments options.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<MileageReferenceItem[]>(null as any);
	}

	/**
	 * Get mileage increments
	 * @return List of no mileage increments options
	 * @deprecated
	 */
	getMillageIncrementOptions(cancelToken?: CancelToken): Promise<MileageReferenceItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetMillageIncrementOptions';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetMillageIncrementOptions(_response);
			});
	}

	protected processGetMillageIncrementOptions(response: AxiosResponse): Promise<MileageReferenceItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<MileageReferenceItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of mileage increments options.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<MileageReferenceItem[]>(null as any);
	}

	/**
	 * Get Protect mileage increments
	 * @return List of no mileage increments options
	 * @deprecated
	 */
	getProtectMillageIncrementOptions(cancelToken?: CancelToken): Promise<MileageReferenceItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetProtectMillageIncrementOptions';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetProtectMillageIncrementOptions(_response);
			});
	}

	protected processGetProtectMillageIncrementOptions(response: AxiosResponse): Promise<MileageReferenceItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<MileageReferenceItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of mileage increments options.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<MileageReferenceItem[]>(null as any);
	}

	/**
	 * Get employment status types
	 * @return List of no mileage increments options
	 */
	getEmploymentStatusTypes(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetEmploymentStatusTypes';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetEmploymentStatusTypes(_response);
			});
	}

	protected processGetEmploymentStatusTypes(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of mileage increments options.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get student course status types
	 * @return List of no student courses options
	 */
	getStudentCourseTypes(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetStudentCourseTypes';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetStudentCourseTypes(_response);
			});
	}

	protected processGetStudentCourseTypes(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of student courses options.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get relationship to proposer types
	 * @return List of no proposer types options
	 */
	getRelationshipToPropserTypes(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetRelationshipToPropserTypes';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetRelationshipToPropserTypes(_response);
			});
	}

	protected processGetRelationshipToPropserTypes(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of proposer types options.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get annual taxi claim free years
	 * @return List of annual taxi claim free years options
	 */
	getAnnualTaxiClaimFreeYears(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetAnnualTaxiClaimFreeYears';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetAnnualTaxiClaimFreeYears(_response);
			});
	}

	protected processGetAnnualTaxiClaimFreeYears(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException(
				'Could not find the list of annual taxi claim free years options.',
				status,
				_responseText,
				_headers,
			);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get NCB years on existing Acorn policy
	 * @return List of NCB years on existing Acorn policy options
	 */
	getNoClaimsBonusYearsCurrentAcornPolicy(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetNoClaimsBonusYearsCurrentAcornPolicy';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetNoClaimsBonusYearsCurrentAcornPolicy(_response);
			});
	}

	protected processGetNoClaimsBonusYearsCurrentAcornPolicy(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException(
				'Could not find the NCB years on existing Acorn policy options.',
				status,
				_responseText,
				_headers,
			);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get Business Radius
	 * @return List of Business Radiuses options
	 */
	getBusinessRadius(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetBusinessRadius';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetBusinessRadius(_response);
			});
	}

	protected processGetBusinessRadius(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find Business Radiuses options.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get Licencing Areas
	 * @return List of Licencing Areas options
	 */
	getLicencingAreas(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetLicencingAreas';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetLicencingAreas(_response);
			});
	}

	protected processGetLicencingAreas(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find Licencing Areas options.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get Operators
	 * @return List of Operator options
	 */
	getOperators(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetOperators';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetOperators(_response);
			});
	}

	protected processGetOperators(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find Operator options.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get Driver Use
	 * @return List of Driver usage options
	 */
	getDriverUse(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetDriverUse';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetDriverUse(_response);
			});
	}

	protected processGetDriverUse(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find Operator options.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get Preferred Contact Methods
	 * @return List of preferred contact method options
	 */
	getPreferredContactMethods(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetPreferredContactMethods';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetPreferredContactMethods(_response);
			});
	}

	protected processGetPreferredContactMethods(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find preferred contact method options.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}

	/**
	 * Get Delivery Operators
	 * @return List of delivery operator options
	 */
	getDeliveryOperators(cancelToken?: CancelToken): Promise<ReferenceDataItem[]> {
		let url_ = this.baseUrl + '/api/v1/ReferenceData/GetDeliveryOperators';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetDeliveryOperators(_response);
			});
	}

	protected processGetDeliveryOperators(response: AxiosResponse): Promise<ReferenceDataItem[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<ReferenceDataItem[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find delivery operator options.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<ReferenceDataItem[]>(null as any);
	}
}

export interface IVehicleClient {
	/**
	 * Get vehicle details by registration
	 * @param vehicleRegistration UK Vehicle registration number.
	 * @return Vehicle details associated to requested registration
	 */
	getVehicleDetailsByVrm(vehicleRegistration: string): Promise<VehicleLookupResponse>;
	/**
	 * Get vehicle makes
	 * @return Vehicle details associated to requested registration
	 */
	getVehicleMakes(): Promise<Make[]>;
	/**
	 * Get vehicle models
	 * @param vehicleMakeCode Vehicle make code from the vehicle model endpoint
	 * @return Retrieves a list of models.
	 */
	getVehicleModels(vehicleMakeCode: string): Promise<Model[]>;
}

export class VehicleClient implements IVehicleClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();

		this.baseUrl = baseUrl ?? URL;
	}

	/**
	 * Get vehicle details by registration
	 * @param vehicleRegistration UK Vehicle registration number.
	 * @return Vehicle details associated to requested registration
	 */
	getVehicleDetailsByVrm(vehicleRegistration: string, cancelToken?: CancelToken): Promise<VehicleLookupResponse> {
		let url_ = this.baseUrl + '/api/v1/Vehicle/GetVehicleDetailsByVrm?';
		if (vehicleRegistration === undefined || vehicleRegistration === null)
			throw new Error("The parameter 'vehicleRegistration' must be defined and cannot be null.");
		else url_ += 'VehicleRegistration=' + encodeURIComponent('' + vehicleRegistration) + '&';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetVehicleDetailsByVrm(_response);
			});
	}

	protected processGetVehicleDetailsByVrm(response: AxiosResponse): Promise<VehicleLookupResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<VehicleLookupResponse>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException(
				'Could not find vehicle associated with requested registration.',
				status,
				_responseText,
				_headers,
			);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<VehicleLookupResponse>(null as any);
	}

	/**
	 * Get vehicle makes
	 * @return Vehicle details associated to requested registration
	 */
	getVehicleMakes(cancelToken?: CancelToken): Promise<Make[]> {
		let url_ = this.baseUrl + '/api/v1/Vehicle/GetVehicleMakes';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetVehicleMakes(_response);
			});
	}

	protected processGetVehicleMakes(response: AxiosResponse): Promise<Make[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<Make[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not get a list of vehicle makes', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<Make[]>(null as any);
	}

	/**
	 * Get vehicle models
	 * @param vehicleMakeCode Vehicle make code from the vehicle model endpoint
	 * @return Retrieves a list of models.
	 */
	getVehicleModels(vehicleMakeCode: string, cancelToken?: CancelToken): Promise<Model[]> {
		let url_ = this.baseUrl + '/api/v1/Vehicle/GetVehicleModels?';
		if (vehicleMakeCode === undefined || vehicleMakeCode === null)
			throw new Error("The parameter 'vehicleMakeCode' must be defined and cannot be null.");
		else url_ += 'VehicleMakeCode=' + encodeURIComponent('' + vehicleMakeCode) + '&';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetVehicleModels(_response);
			});
	}

	protected processGetVehicleModels(response: AxiosResponse): Promise<Model[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<Model[]>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not get a list of models.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<Model[]>(null as any);
	}
}

export interface IVersionClient {
	/**
	 * @param x_Product This will need to be set for product
	 * @return OK
	 */
	getVersionInfo(x_Product: string): Promise<VersionResponse>;
}

export class VersionClient implements IVersionClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();

		this.baseUrl = baseUrl ?? URL;
	}

	/**
	 * @param x_Product This will need to be set for product
	 * @return OK
	 */
	getVersionInfo(x_Product: string, cancelToken?: CancelToken): Promise<VersionResponse> {
		let url_ = this.baseUrl + '/api/v1/Version/GetVersionInfo';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				'X-Product': x_Product !== undefined && x_Product !== null ? '' + x_Product : '',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetVersionInfo(_response);
			});
	}

	protected processGetVersionInfo(response: AxiosResponse): Promise<VersionResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<VersionResponse>(result200);
		} else if (status === 500) {
			const _responseText = response.data;
			return throwException('Internal Server Error', status, _responseText, _headers);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<VersionResponse>(null as any);
	}
}

export interface AllReferenceData {
	/** Dynamic list of reference data from ICE */
	referenceData?: any | undefined;
}

export interface BankCheckerResponse {
	/** Name of associated bank */
	bankName: string;
	/** Is a valid matching sortcode and account number */
	isValid: boolean;
}

export interface CheckBankDetailsCommand {
	/** Valid UK bank sortcode */
	sortCode: string;
	/** Valid matching UK account number */
	accountNumber: string;
}

export interface FullAddress {
	/** Department */
	department?: string | undefined;
	/** Company */
	company?: string | undefined;
	/** Sub building */
	subBuilding?: string | undefined;
	/** Building number */
	buildingNumber?: string | undefined;
	/** Name of Building */
	buildingName?: string | undefined;
	/** Secondary Street */
	secondaryStreet?: string | undefined;
	/** Street */
	street?: string | undefined;
	/** Block */
	block?: string | undefined;
	/** Neighbourhood */
	neighbourhood?: string | undefined;
	/** District */
	district?: string | undefined;
	/** City */
	city?: string | undefined;
	/** Line 1 of address */
	line1?: string | undefined;
	/** Line 2 of address */
	line2?: string | undefined;
	/** Line 3 of address */
	line3?: string | undefined;
	/** line 4 of address */
	line4?: string | undefined;
	/** Line 5 of address */
	line5?: string | undefined;
	/** Post Code */
	postalCode?: string | undefined;
	/** County */
	county?: string | undefined;
	/** Country */
	country?: string | undefined;
}

export interface Make {
	code?: string;
	name?: string;

	[key: string]: any;
}

export interface MileageReferenceItem {
	/** The top value of the band as an (int) */
	value: number;
	/** Milage banding */
	label: string;
}

export enum MileageTypes {
	Default = 'Default',
	Protect = 'Protect',
	ShortTerm = 'ShortTerm',
}

export interface Model {
	code?: string;
	name?: string;
	capacity?: number;
	weight?: number;
	doors?: number;
	fuel?: string;
	trans?: string;
	syear?: number;
	eyear?: number;

	[key: string]: any;
}

export interface ProblemDetails {
	type?: string | undefined;
	title?: string | undefined;
	status?: number | undefined;
	detail?: string | undefined;
	instance?: string | undefined;

	[key: string]: any;
}

export interface RefData {
	code?: string;
	desc?: string;
	lang?: string;

	[key: string]: any;
}

export interface ReferenceDataItem {
	/** This is the "code value" within ICE that needs to be passed through as a string to the quote. */
	value: string;
	/** This is the reference or dropdown value description to be displayed to the user. */
	label: string;
	/** Filter list by the value, from parent selection. ie. Filter Vehicle Model by Vehicle Make */
	filterBy?: string | undefined;
	/** Lets the client know if reference should be a pinned button. */
	isButton?: boolean;
	/** Option is used to hide dropdown values in the client */
	isHidden?: boolean;
}

export interface SearchResult {
	/** Address summary of a matched address result. */
	searchResult: string;
	itemId?: string;
	partialResult?: boolean;

	[key: string]: any;
}

export interface StoreUrls {
	android?: string | undefined;
	ios?: string | undefined;
}

export interface Vehicle {
	bodyType?: RefData;
	/** Vehicle Cubic Capacity */
	cubicCapacity?: number;
	fuelType?: RefData;
	make?: RefData;
	model?: RefData;
	/** Vehicle Year */
	year?: number;
	/** Year vehicle manufactured from */
	manufacturedFromYear?: number;
	/** Year Vehicle manufactured to */
	manufacturedToYear?: number;
	numberOfDoors?: RefData;
	/** Vehicle Registration Date */
	registrationDate?: string;
	/** Number of seats in vehicle */
	numberOfSeats?: string;
	/** Vehicle Registration Number */
	registrationNumber?: string;
	transmission?: RefData;
	/** Vehicle Value */
	value?: number;
	vehicleLeftRightDrive?: RefData;
	/** Vehicle's Gross Weight */
	grossWeight?: string;
	/** Vehicle Identification Number */
	vehicleIdentificationNumber?: string;
	/** Vehicle Power Weight Ratio */
	powerWeightRatio?: string;
	vehicleType?: RefData;
	engineType?: RefData;
	color?: RefData;
	insuranceGroup?: RefData;
	insuranceTerms?: RefData;
	/** Vehicle Mileage */
	mileage?: string;
	/** Size of the engine */
	engineSize?: string;
	abicode?: string;
	gtacategory?: RefData;
	abigroup?: string;

	[key: string]: any;
}

export interface VehicleFinanceData {
	companyName?: string;
	financeType?: RefData;
	agreementNumber?: string;
	loanStartDate: string;
	loanEndDate: string;
	originalAmount?: string;
	outstandingAmount?: string;
	settlementAmount?: string;
	settlementValidity?: string;
	notes?: string;

	[key: string]: any;
}

export interface VehicleLookupResponse {
	isCommercialVehicle?: boolean;
	isMotorCycle?: boolean;
	vehicleInfo: Vehicle;
	vehicleFinanceData?: VehicleFinanceData;
	/** Returns any report document associated with the lookup. */
	vehicleLookupReport?: string[];

	[key: string]: any;
}

export interface VersionResponse {
	minVersion?: string | undefined;
	storeUrls?: StoreUrls;
}

export interface VolunaryExcessReferenceItem {
	/** Voluntary excess amount as a decimal */
	value: number;
	/** Voluntary excess amount in (£) */
	label: string;
}

export class SwaggerException extends Error {
	override message: string;
	status: number;
	response: string;
	headers: { [key: string]: any };
	result: any;

	constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
		super();

		this.message = message;
		this.status = status;
		this.response = response;
		this.headers = headers;
		this.result = result;
	}

	protected isSwaggerException = true;

	static isSwaggerException(obj: any): obj is SwaggerException {
		return obj.isSwaggerException === true;
	}
}

function throwException(
	message: string,
	status: number,
	response: string,
	headers: { [key: string]: any },
	result?: any,
): any {
	if (result !== null && result !== undefined) throw result;
	else throw new SwaggerException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
	return obj && obj.isAxiosError === true;
}
